import { render, staticRenderFns } from "./PosStudioSelect.vue?vue&type=template&id=32bf7a31"
import script from "./PosStudioSelect.vue?vue&type=script&lang=js"
export * from "./PosStudioSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports